var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0656 16.7917C13.8132 16.7917 16.8512 13.7882 16.8512 10.0833C16.8512 6.37842 13.8132 3.375 10.0656 3.375C6.31804 3.375 3.28003 6.37842 3.28003 10.0833C3.28003 13.7882 6.31804 16.7917 10.0656 16.7917Z",
    stroke: "#616161",
    strokeWidth: 1.64286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7286 20.625L14.9124 14.875",
    stroke: "#616161",
    strokeWidth: 1.64286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2649,
    height: 23,
    fill: "white",
    transform: "translate(0.371826 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchGrey);
export default __webpack_public_path__ + "static/media/Icon_Search_Grey.9ffb2569b7a38b32d5f32a6ea2ea6e48.svg";
export { ForwardRef as ReactComponent };